import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import ProductOrderListByStockoutProduct from 'components/stockoutproducttoproductorder/components/ProductOrderListByStockoutProduct';

export default function StockoutproductForStockOutReqId({ stockOutReqId }) {
  const { stockoutproductList } = useSelector((state) => state.manufslice);
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    if (stockoutproductList && stockoutproductList.length > 0) {
      const filteredProducts = stockoutproductList.filter(product => product.stockoutreqid === stockOutReqId);
      setProductList(filteredProducts);
    }
  }, [stockoutproductList]);
  return (
    <>
      {productList.map((product, index) => (
        <Grid
          container
          direction="row"
          sx={{
            borderBottom: index !== productList.length - 1 ? '1px solid #c4c4c4' : 'none',
            padding: 1,
            backgroundColor: 'secondary.200',
            justifyContent: "flex-start",
            alignItems: "center",
            width: '100%'
          }}
          key={index}
        >

          <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%' }}>
            <Grid item lg={3} xs={3} >
              {product.title}
            </Grid>
            <Grid item lg={3} xs={3} >
              {product.qty}
            </Grid>
            <Grid item lg={6} xs={6} >
              <ProductOrderListByStockoutProduct stockoutproductid={product.id} />
            </Grid>
          </Grid>
        </Grid>
      ))}
    </>
  );


}